export default "__VITE_ASSET__BpX89mmG__"